export const QUICK_FILTERS = [
    {
        value: "all",
        label: "All",
    },
    {
        value: "with_name",
        label: "With Name",
    },
    {
        value: "no_name",
        label: "No Name",
    },
    {
        value: "this_week",
        label: "This Week",
    },
    {
        value: "this_month",
        label: "This Month",
    },
];

export const SORT_OPTIONS = [
    {
        value: "newest",
        label: "Newest First",
    },
    {
        value: "oldest",
        label: "Oldest First",
    },
    {
        value: "name_asc",
        label: "Name A-Z",
    },
    {
        value: "name_desc",
        label: "Name Z-A",
    },
    {
        value: "phone_asc",
        label: "Phone 0-9",
    },
    {
        value: "phone_desc",
        label: "Phone 9-0",
    },
    {
        value: "status_asc",
        label: "Status A-Z",
    },
    {
        value: "status_desc",
        label: "Status Z-A",
    },
];

export const TAG_OPTIONS = [
    {
        value: "all",
        label: "All Tags",
    },
    {
        value: "new",
        label: "New",
    },
    {
        value: "customer",
        label: "Customer",
    },
    {
        value: "vip",
        label: "VIP",
    },
    {
        value: "follow_up",
        label: "Follow Up",
    },
];
